export const emailNew = [
  '0 0 32 32',
  `
<path fill="none"  stroke-width="2.6667" stroke-miterlimit="4" stroke-linecap="round" stroke-linejoin="round" d="M5.333 1.778h28.444c1.956 0 3.556 1.6 3.556 3.556v21.333c0 1.956-1.6 3.556-3.556 3.556h-28.444c-1.956 0-3.556-1.6-3.556-3.556v-21.333c0-1.956 1.6-3.556 3.556-3.556z"></path>
<path fill="none"  stroke-width="2.email6667" stroke-miterlimit="4" stroke-linecap="round" stroke-linejoin="round" d="M37.333 5.333l-17.778 12.444-17.778-12.444"></path>

`,
]
